import React from 'react';
import DirectionsWalk from '@mui/icons-material/DirectionsWalk';
import DirectionsRun from '@mui/icons-material/DirectionsRun';
import FavoriteBorder from '@mui/icons-material/FavoriteBorder';
import MonitorHeartOutlined from '@mui/icons-material/MonitorHeartOutlined';
import Thermostat from '@mui/icons-material/Thermostat';
import BedtimeOutlined from '@mui/icons-material/BedtimeOutlined';
import TimerOutlined from '@mui/icons-material/TimerOutlined';
import BloodtypeOutlined from '@mui/icons-material/BloodtypeOutlined';
import Air from '@mui/icons-material/Air';
import GridView from '@mui/icons-material/GridView';
import type { SvgIconComponent } from '@mui/icons-material';
import type { MetricInput } from '../../collection/metrics/types';
import { metricPresentation, ultrahumanMetricKey } from './presentation';

const icons: Record<string, SvgIconComponent> = {
  hr: FavoriteBorder, hrv: MonitorHeartOutlined, temp: Thermostat, steps: DirectionsWalk,
  night_rhr: FavoriteBorder, sleep_rhr: FavoriteBorder, avg_sleep_hrv: MonitorHeartOutlined,
  sleep: BedtimeOutlined, morning_alertness: BedtimeOutlined, spo2: BloodtypeOutlined,
  motion: DirectionsRun, movement_index: DirectionsRun, movements: DirectionsRun,
  active_minutes: TimerOutlined, inactive_time: TimerOutlined, weekly_active_minutes: TimerOutlined,
  recovery: MonitorHeartOutlined, recovery_index: MonitorHeartOutlined, vo2_max: Air,
  glucose: BloodtypeOutlined, average_glucose: BloodtypeOutlined, glucose_variability: BloodtypeOutlined,
  metabolic_score: BloodtypeOutlined, hba1c: BloodtypeOutlined, time_in_target: BloodtypeOutlined,
};
export default function UltrahumanMetricIcon({ metric }: { metric: MetricInput }) {
  const Icon = icons[ultrahumanMetricKey(metric).replace(/_summary$/, '')] || GridView;
  return <Icon aria-hidden="true" sx={{ fontSize: 20, flexShrink: 0, color: metricPresentation(metric).color }} />;
}
